import * as React from 'react';
import styled from 'styled-components';
import type { IconProps } from './types';

type MaskProps = {
    $width: number;
    $height: number;
    $fill?: string;
};

const Mask = styled.span<MaskProps>`
    display: inline-block;
    width: ${p => p.$width}px;
    height: ${p => p.$height}px;
    ${p => (p.$fill ? `color: ${p.$fill};` : '')}
    background: currentColor;
    filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.6));
    -webkit-mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="white" d="M8.07143 8.87142L7.5 10.8L6.92857 8.87142L5 8.29999L6.92857 7.72856L7.5 5.79999L8.07143 7.72856L10 8.29999L8.07143 8.87142ZM16 20L17.6 14.6L23 13L17.6 11.4L16 6.00002L14.4 11.4L9 13L14.4 14.6L16 20ZM7.5 21L8.3 18.3L11 17.5L8.3 16.7L7.5 14L6.7 16.7L4 17.5L6.7 18.3L7.5 21Z"/></svg>')
        no-repeat center / contain;
    mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="white" d="M8.07143 8.87142L7.5 10.8L6.92857 8.87142L5 8.29999L6.92857 7.72856L7.5 5.79999L8.07143 7.72856L10 8.29999L8.07143 8.87142ZM16 20L17.6 14.6L23 13L17.6 11.4L16 6.00002L14.4 11.4L9 13L14.4 14.6L16 20ZM7.5 21L8.3 18.3L11 17.5L8.3 16.7L7.5 14L6.7 16.7L4 17.5L6.7 18.3L7.5 21Z"/></svg>')
        no-repeat center / contain;
`;

const Sparkles: React.FC<IconProps & React.ComponentPropsWithoutRef<'span'>> = ({
    width = 24,
    height = 24,
    fill,
    style,
    className,
    ...rest
}) => (
    <Mask
        $width={width || 24}
        $height={height || 24}
        $fill={fill}
        aria-hidden="true"
        style={style}
        className={className}
        {...rest}
    />
);

export default Sparkles;
